import { render } from "./CurrencyInput.vue?vue&type=template&id=754bb8c7&scoped=true&ts=true"
import script from "./CurrencyInput.vue?vue&type=script&lang=ts"
export * from "./CurrencyInput.vue?vue&type=script&lang=ts"

import "./CurrencyInput.vue?vue&type=style&index=0&id=754bb8c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754bb8c7"]])

export default __exports__